<style lang="scss" type="text/scss">
  .stat :global(.button) {
    background: #eee;
    padding: 16px;
    border-radius: 4px;
    margin: 0;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 14px;
  }

  .stat :global(.button.primary) {
    background: #ff6452;
    padding: 16px;
    border-radius: 4px;
    margin: 0;
    font-family: proxima-nova, sans-serif;
    font-weight: 700;
    color: #fff;
    font-size: 14px;
  }

  .stat-darker {
    padding: 16px;
    margin: 16px;
  }

  .selected {
    border:1px solid #ff6452;
  }

  div h3 {
    color: #ff6452;
  }
</style>

<script>
  import {getContext} from 'svelte';
  import AppLink from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';
  import {addNotification, ICONS} from '../../../utils/notifications.store';
  import {ADMIN_ADD_REGISTRATION, EVENT_ATTENDEES} from '../../../graphql/events';
  import moment from 'moment';
  export let household;
  export let event;
  export let waitlist = false;
  let people = household.people;


  $: disabled = people.filter((person) => person.selected).length === 0;

  const client = getContext('apollo');

  function selectPerson(i) {
    people[i].selected= people[i].selected ? false : true;
  }

  async function addRegistration() {
    if(disabled) return;

    try {
      await client.mutate({mutation: ADMIN_ADD_REGISTRATION, variables: {
        input: {
          event: event,
          waitlist: waitlist,
          account: household.id,
          people: people.filter((person) => {
            return person.selected
          }).map((person) => {
            return person.id;
          })
        }
      }, refetchQueries:[{query: EVENT_ATTENDEES, variables: {id: event, waitlist: waitlist} }]})
      addNotification({time: 3000, message:`Added Household`, icon: ICONS.SUCCESS})
      window.location.reload();
    } catch (e) {
      addNotification({time: 3000, message:`Could not add household. Registration already exists`, icon: ICONS.ERROR})
    }
  }
</script>

<Card>
  <AppLink to="{`/households/view/${household.primary.id}`}">
    <h3 class="u--padall">
      {household.primary.person.lastName} Household
    </h3>
  </AppLink>
  <hr />
  
  <div class="stat-darker">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="u--pad-vertical">
          <h4>Select 1 or more people below to add registration.</h4>
        </div>
      </div>
    </div>
    <div class="grid-x grid-margin-x small-up-12 medium-up-2">
     
      {#each people as person, i (person.id)}
        <div class="cell">
          <Card bordered hover selected={person.selected} on:click={() => selectPerson(i)}>
            <div class="u--padall">
              <div class="grid-x">
                <div class="small-12 medium-2">
                  <Avatar photo={person.avatar} />
                </div>
                <div class="small-12 medium-10">
                  <h3>{person.firstName} {person.lastName}</h3>
                  <h4>{person.relationship}</h4>
                </div>
              </div>
            </div>
          </Card>
        </div>
      {/each}
    </div>
  </div>
  
  <div class="stat">
    <div class="grid-x">
      
      <div class="cell small-12 medium-12 text-center">
        <div on:click={addRegistration} class:primary="{!disabled}"  class="button">
          {disabled ? `Select 1 or more people above to add registration.` : `Add Registration`}
        </div>
      </div>
    </div>
  </div>
</Card>